import { format } from "date-fns";
import {
	Button,
	FormControl,
	FormControlLabel,
	FormLabel,
	Grid,
	InputLabel,
	LinearProgress,
	MenuItem,
	Paper,
	Radio,
	RadioGroup,
	Select,
	ThemeProvider,
	TextField,
	Tooltip,
	Typography
} from "@mui/material";
import MUIDataTable from "mui-datatables";
import IconButton from "@mui/material/IconButton";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import RemoveIcon from "@mui/icons-material/Remove";
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import { useEffect, useState } from "react";
import { getUsuarios, getUsuario } from "../../../services/UsuarioService";
import UsuarioDialog from "./UsuarioDialog";
import Message from "../../../utils/Message";
import { Box } from "@mui/system";

import React from 'react';



const initialState = {
	nombre: "",
	apellido: "",
	origenDatos: "todo",
	estado: "habilitado",
	orden: "ASC",
	ordenarPor: "apellido",
	rows: 0,
	first: 0,
};

const origenDatosOptions = [
	{
		id: "todo",
		descripcion: "Todo",
	},
	{
		id: "manual",
		descripcion: "Manual",
	},
	{
		id: "automatico",
		descripcion: "Automático",
	},
];

const estadoOptions = [
	{
		id: "todo",
		descripcion: "Todo",
	},
	{
		id: "habilitado",
		descripcion: "Habilitado",
	},
	{
		id: "deshabilitado",
		descripcion: "Deshabilitado",
	},
];

const ordenOptions = [
	{
		id: "ASC",
		descripcion: "Ascendente",
	},
	{
		id: "DESC",
		descripcion: "Descendente",
	},
];

const ordenarPorOptions = [
	{
		id: "apellido",
		descripcion: "Apellido",
	},
	{
		id: "nombre",
		descripcion: "Nombre",
	},
	{
		id: "username",
		descripcion: "Usuario",
	},
	{
		id: "origen_datos",
		descripcion: "Origen de Datos",
	},
];

const sexoRegistradoAlNacerOptions = [
	{ value: 'M', label: 'Masculino' },
	{ value: 'F', label: 'Femenino' },
];

const nameItemsText = "Usuarios";
//
// #####################################################################################################################
//
const UsuarioTable = ({ ...data }) => {
	const [searchData, setSearchData] = useState(initialState);
	const [itemsCrud, setItemsCrud] = useState([]);
	const [itemCrud, setItemCrud] = useState({});
	const [actionCrud, setActionCrud] = useState("");
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [totalRowsCount, setTotalRowsCount] = useState(0);
	const [currentPage, setCurrentPage] = useState(0);
	const [openDialog, setOpenDialog] = useState(false);
	const [message, setMessage] = useState({});
	const [showMessage, setShowMessage] = useState(false);
	const [isDoingSomething, setIsDoingSomething] = useState(false);




	const tableColumns = [
		{
			name: "id",
			label: "ID",
			options: {
				display: "excluded",
			},
		},
		{
			name: "apellido",
			label: "Apellido",
			options: {
				filter: false,
				sort: false,
			},
		}, {
			name: "nombre",
			label: "Nombre",
			options: {
				filter: false,
				sort: false,
			},
		},
		{
			name: "username",
			label: "Usuario",
			options: {
				filter: false,
				sort: false,
			},
		},
		{
			name: "origen_datos",
			label: "Origen de Datos",
			options: {
				filter: false,
				sort: false,
			},
		},
		{
			name: "actions",
			label: "Acciones",
			options: {
				filter: false,
				sort: false,
				empty: true,
				customBodyRenderLite: (dataIndex, rowIndex) => (
					<>
						{itemsCrud[dataIndex].habilitado && (
							<Tooltip title="Editar">
								<IconButton
									size="small"
									aria-label="update"
									onClick={() => handleClickActionCrud(itemsCrud[dataIndex], "update")}
								>
									<EditOutlinedIcon />
								</IconButton>
							</Tooltip>
						)}

						{itemsCrud[dataIndex].habilitado && (
							<Tooltip title="Deshabilitar">
								<IconButton
									size="small"
									aria-label="disable"
									onClick={() => handleClickActionCrud(itemsCrud[dataIndex], "disable")}
								>
									<RemoveIcon />
								</IconButton>
							</Tooltip>
						)}

						{!itemsCrud[dataIndex].habilitado && (
							<Tooltip title="Habilitar">
								<IconButton
									size="small"
									aria-label="enable"
									onClick={() => handleClickActionCrud(itemsCrud[dataIndex], "enable")}
								>
									<AddIcon />
								</IconButton>
							</Tooltip>
						)}
						{(
							<Tooltip title="Ver">
								<IconButton
									size="small"
									aria-label="read"
									onClick={() => handleClickActionCrud(itemsCrud[dataIndex], "read")}
								>
									<ZoomInIcon />
								</IconButton>
							</Tooltip>
						)}
					</>
				),
			},
		},
	];

	const tableOptions = {
		storageKey: "my-table-state",
		rowsPerPageOptions: [10, 20, 30],
		serverSide: true,
		count: totalRowsCount,
		rowsPerPage: rowsPerPage,
		onChangeRowsPerPage: (numberOfRows) => {
			setRowsPerPage(numberOfRows);
		},
		onChangePage: (currentPage) => {
			setCurrentPage(currentPage);
		},
		download: false,
		filter: false,
		print: false,
		search: false,
		viewColumns: false,
		selectableRowsHeader: false,
		selectableRows: "none",
		elevation: 1,
		textLabels: {
			body: {
				noMatch: "No se han encontrado resultados para esta búsqueda",
			},
			pagination: {
				next: "Próxima",
				previous: "Previa",
				rowsPerPage: "Filas:",
				displayRows: "de",
			},
		},
	};
	//
	// ################################################################################ 
	//
	const load = async () => {
		searchData.rows = rowsPerPage;
		searchData.first = currentPage * rowsPerPage;
		searchData.sortField = searchData.ordenarPor;
		searchData.sortOrder = searchData.orden;

		setIsDoingSomething(true);
		const response = await getUsuarios(searchData);
		setIsDoingSomething(false);

		if (response.ok) {
			setItemsCrud(response.data.data);
			setTotalRowsCount(response.data.count);
		} else {
			setMessage({
				messageText: response.messageText,
				severity: response.messageSeverity,
			});
			setShowMessage(true);
		}
	};

	useEffect(() => {
		load();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentPage, rowsPerPage]);

	const handleChange = (e) => {
		setSearchData({
			...searchData,
			[e.target.name]:
				e.target.type === "checkbox" ? e.target.checked : e.target.value,
		});
	};

	const search = () => {
		setCurrentPage(0);
		load();
	};

	const clean = () => {
		setSearchData(initialState);
		setItemsCrud([]);
	};

	const handleClickActionCrud = (itemCrud, action) => {
		let _itemCrud = {};

		if (action !== "create") {
			const loadItem = async () => {
				setIsDoingSomething(true);
				const response = await getUsuario({ id: itemCrud.id });
				setIsDoingSomething(false);

				console.log("response: ", response)

				if (response.ok) {
					_itemCrud = {
						id: response.data.data.id,
						tipoDocumento: response.data.data.tipo_documento,
						nroDocumento: response.data.data.nro_documento,
						sexoRegistradoAlNacer: response.data.data.sexo_registrado_al_nacer,
						apellido: response.data.data.apellido,
						nombre: response.data.data.nombre,
						username: response.data.data.username,
						legajo: response.data.data.legajo,
						matricula: response.data.data.matricula,
						cuil: response.data.data.cuil,
						email: response.data.data.email,
						genero: response.data.data.genero,
						fechaNacimiento:
							response.data.data.fecha_nacimiento !== ""
								? format(
									new Date(response.data.data.fecha_nacimiento),
									"yyyy/MM/dd"
								)
								: null,
						telefonoMovil: response.data.data.telefono_movil,
						estadoUltimo: response.data.data.estado_ultimo,
						fechaEstadoUltimo:
							response.data.data.fecha_estado_ultimo !== ""
								? format(
									new Date(response.data.data.fecha_estado_ultimo),
									"yyyy/MM/dd"
								)
								: null,
						codigoExterno: response.data.data.codigo_externo,
						origenDatos: response.data.data.origen_datos,
						fechaCreacion: response.data.data.fecha_creacion,
						fechaActualizacion: response.data.data.fecha_actualizacion,
						nombreUsuario: response.data.data.nombre_usuario_actualiza,
						apellidoUsuario: response.data.data.apellido_usuario_actualiza,
						username_actualiza: response.data.data.username_usuario_actualiza,
						fotoPerfil: response.data.data.foto_perfil,
					};

					setActionCrud(action);
					setItemCrud(_itemCrud);
					setOpenDialog(true);
				} else {
					setMessage({
						severity: response.messageSeverity,
						messageText: response.messageText,
					});
					setShowMessage(true);
					return;
				}
			};
			loadItem();
		} else {
			setActionCrud(action);
			setItemCrud(_itemCrud);
			setOpenDialog(true);
		}
	};

	const handleDialogSave = () => {
		load();
		setOpenDialog(false);
	};

	const handleDialogClose = () => {
		setOpenDialog(false);
	};

	// let table = data.data.table

	return (
		<>
			<Paper

				elevation={2}
			>
				<Box
					sx={{
						margin: "auto",
						width: "90%",
					}}
				>
					<Box sx={{ m: 1, p: 1 }}>
						<Grid container spacing={1}>
							<Grid item xs={12}>
								<h2>{nameItemsText}</h2>
							</Grid>
							<Grid item xs={12} md={6} lg={3}>
								<TextField
									sx={{ width: "100%", mr: 1, pb: 1 }}
									id="apellido"
									name="apellido"
									value={searchData.apellido}
									onChange={handleChange}
									label="Apellido"
									variant="outlined"
									size="small"
								/>
							</Grid>
							<Grid item xs={12} md={6} lg={3}>
								<TextField
									sx={{ width: "100%", mr: 1 }}
									id="nombre"
									name="nombre"
									value={searchData.nombre}
									onChange={handleChange}
									autoFocus={true}
									label="Nombre"
									variant="outlined"
									size="small"
								/>
							</Grid>
							<Grid item xs={12} md={6} lg={3}>
								<FormControl sx={{ width: "100%" }}>
									<InputLabel id="origen-datos-select-label">
										Origen de Datos
									</InputLabel>
									<Select
										sx={{ width: "100%", mr: 1 }}
										labelId="origenDatos"
										label="Origen de Datos"
										id="origenDatos"
										name="origenDatos"
										value={searchData.origenDatos}
										size="small"
										onChange={handleChange}
									>
										{origenDatosOptions.map((item) => (
											<MenuItem key={item.id} value={item.id}>
												{item.descripcion}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>
							<Grid item xs={12} md={6} lg={3}>
								<FormControl sx={{ width: "100%" }}>
									<InputLabel id="estado-select-label">Estado</InputLabel>
									<Select
										sx={{ width: "100%", mr: 1 }}
										labelId="estado"
										label="Estado"
										id="estado"
										name="estado"
										value={searchData.estado}
										size="small"
										onChange={handleChange}
									>
										{estadoOptions.map((item) => (
											<MenuItem key={item.id} value={item.id}>
												{item.descripcion}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>
						</Grid>
					</Box>

					<Box sx={{ m: 1, p: 1 }}>
						<Grid container spacing={1}>
							<Grid item xs={12} md={3}>
								<FormControl sx={{ width: "100%" }}>
									<InputLabel id="ordenarPor-select-label">
										Ordenar por:
									</InputLabel>
									<Select
										sx={{ width: "100%", mr: 1 }}
										labelId="ordenarPor"
										label="Ordenar por:"
										id="ordenaPor"
										name="ordenarPor"
										value={searchData.ordenarPor}
										size="small"
										onChange={handleChange}
									>
										{ordenarPorOptions.map((item) => (
											<MenuItem key={item.id} value={item.id}>
												{item.descripcion}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>
							<Grid item xs={12} md={4}>
								<Grid container spacing={2}>
									<Grid item xs={6}>
										<FormControl component="fieldset">
											<Box display="flex" alignItems="center" sx={{ '& .MuiFormControlLabel-root': { pl: 3 } }}>
												<Typography variant="subtitle1" component="span" sx={{ ml: 1 }}>
													Ordenar
												</Typography>
												<RadioGroup
													aria-label="Orden"
													name="orden"
													value={searchData.orden}
													onChange={handleChange}
													row
												>
													{ordenOptions
														.slice(0, Math.ceil(ordenOptions.length / 2))
														.map((item) => (
															<FormControlLabel
																key={item.id}
																value={item.id}
																label={item.descripcion}
																control={<Radio />}
															/>
														))}
												</RadioGroup>
												<RadioGroup
													aria-label="Orden"
													name="orden"
													value={searchData.orden}
													onChange={handleChange}
													row
												>
													{ordenOptions
														.slice(Math.ceil(ordenOptions.length / 2))
														.map((item) => (
															<FormControlLabel
																key={item.id}
																value={item.id}
																label={item.descripcion}
																control={<Radio />}
															/>
														))}
												</RadioGroup>
											</Box>
										</FormControl>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</Box>

					<Box sx={{ m: 1, p: 1 }}>
						<Grid container spacing={1}>
							<Grid item xs={12} md={3} lg={2}>
								<Button
									sx={{ width: "100%" }}
									variant="contained"
									size="small"
									onClick={() => handleClickActionCrud({}, "create")}
									startIcon={<AddIcon />}
								>
									Nuevo
								</Button>
							</Grid>
							<Grid item xs={12} md={3} lg={2}>
								<Button
									sx={{ width: "100%", mr: 1 }}
									variant="outlined"
									size="small"
									onClick={clean}
									startIcon={<CleaningServicesIcon />}
								>
									Limpiar
								</Button>

							</Grid>
							<Grid item xs={12} md={3} lg={2}>
								<Button
									sx={{ width: "100%" }}
									variant="contained"
									size="small"
									onClick={search}
									startIcon={<SearchIcon />}
								>
									Buscar
								</Button>

							</Grid>
						</Grid>
					</Box>

					<Box sx={{ m: 1, p: 1 }}>
					</Box>
					{isDoingSomething && <LinearProgress />}


					<MUIDataTable columns={tableColumns} data={itemsCrud} options={tableOptions} />

				</Box>
			</Paper>

			{/* >>>> Dialog */}

			{openDialog && (
				<UsuarioDialog
					onSave={handleDialogSave}
					onClose={handleDialogClose}
					itemCrud={itemCrud}
					actionCrud={actionCrud}
					setMessage={setMessage}
					setShowMessage={setShowMessage}
				/>
			)}

			{/* >>>> Messages */}

			{showMessage && (
				<Message
					showMessage={showMessage}
					setShowMessage={setShowMessage}
					message={message}
				/>
			)}
		</>
	);
};

export default UsuarioTable;
